/* eslint-disable no-underscore-dangle */
import React from 'react';
import { ProviderProps } from '@app/shell/types';
import {
  dehydrate,
  DehydratedState,
  Hydrate,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { isServer, ironBuildVersionIsV4 } from '@app/utils';

let clientDehydratedState: DehydratedState | undefined;
let clientQueryClient: QueryClient;

if (!isServer && !ironBuildVersionIsV4) {
  clientQueryClient = new QueryClient();
  clientDehydratedState =
    (window?.__REACT_QUERY_STATE__ as DehydratedState) ?? undefined;
}

const ReactQueryProvider = ({ children, req }: ProviderProps) => {
  let queryClient: QueryClient;
  let dehydratedState: DehydratedState | undefined;

  if (ironBuildVersionIsV4) {
    // nextjs case applies to both client and serverside nextjs
    queryClient = new QueryClient();
    dehydratedState = req?.appContext?.states?.query?.value;
  } else if (isServer) {
    // on the current server this comes precreated from buildReqContext and passes through getDataForRoute
    queryClient = req?.appContext?.queryClient as QueryClient;
    dehydratedState = dehydrate(queryClient);
  } else {
    queryClient = clientQueryClient;
    dehydratedState = clientDehydratedState;
  }

  const [savedClient] = React.useState(queryClient);

  return (
    <QueryClientProvider client={savedClient}>
      <Hydrate state={dehydratedState}>{children}</Hydrate>
    </QueryClientProvider>
  );
};

export default ReactQueryProvider;
